module.exports = __webpack_public_path__ + "static/media/Gucci-Dionysus.01fa801f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/bags/Gucci-Dionysus.png
// module id = 219
// module chunks = 0